<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="132px">
          <el-row :gutter="24">
            <el-col :span="8">
              <!-- -->
              <el-form-item label="优惠券管理代码：" prop="couponCode">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.couponCode"
                  filterable
                >
                  <template v-for="(value, key) in dictData['coupon_code']">
                    <el-option
                      :key="value.value"
                      :label="`${value.label}`"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="优惠券名称：" prop="couponName">
                <el-input
                  size="small"
                  v-model="queryParams.couponName"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否启用：" prop="isEnable">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.isEnable"
                >
                  <template
                    v-for="(value, key) in dictData['sys_normal_disable']"
                  >
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="操作时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-button type="primary" size="small" @click="handleShowCoupon"
                >新增</el-button
              >
            </el-col>
            <el-col :span="16" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table border :data="tableData">
        <el-table-column label="优惠券管理代码" prop="couponCode">
          <template slot-scope="scope">
            {{ dictMap["coupon_code"][scope.row.couponCode] }}
          </template>
        </el-table-column>
        <el-table-column label="优惠券名称" prop="couponName">
        </el-table-column>
        <el-table-column label="是否启用" prop="isEnable">
          <template slot-scope="scope">
            <div>{{ scope.row.isEnable == "1" ? "正常" : "停用" }}</div>
          </template></el-table-column
        >
        <el-table-column label="已发放" prop="giveNum">
          <template slot-scope="scope">
            <a
              style="cursor:pointer;"
              @click.prevent="handleShowDetail(scope.row)"
              >{{ scope.row.giveNum }}</a
            >
          </template>
        </el-table-column>
        <el-table-column label="操作人员" prop="operNo" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operNo }}
          </template>
        </el-table-column>
        <el-table-column label="操作时间" prop="createTime">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="1280px"
    >
      <el-table style="height: 60vh;overflow-y:auto;" border :data="giveList">
        <el-table-column width="161" label="创建时间" prop="createTime">
        </el-table-column>
        <el-table-column label="商家账号" prop="pOperNo"> </el-table-column>
        <el-table-column label="优惠券码" prop="couponNo"> </el-table-column>
        <el-table-column label="优惠券名称" prop="couponName">
        </el-table-column>
        <el-table-column label="优惠券类型" prop="couponType">
          <template slot-scope="scope">
            {{ dictMap["coupon_type"][scope.row.couponType] }}
          </template>
        </el-table-column>
        <el-table-column label="优惠券开始时间" prop="startTime">
        </el-table-column>
        <el-table-column label="优惠券结束时间" prop="endTime">
        </el-table-column>
        <el-table-column label="使用条件" prop="useFull">
          <template slot-scope="scope">
            {{ scope.row.useFull }}元
          </template></el-table-column
        >
        <el-table-column label="减/折扣" prop="discount">
          <template slot-scope="scope">
            {{ scope.row.discount
            }}{{ scope.row.couponType == "01" ? "元" : "折" }}
          </template>
        </el-table-column>
        <el-table-column label="优惠券状态" prop="couponStatus">
          <template slot-scope="scope">
            {{ dictMap["coupon_status"][scope.row.couponStatus] }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >关闭</el-button
        >
        <el-button v-if="isEdit" type="primary" size="small" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="addDialog.title"
      :visible.sync="addDialog.dialogVisible"
      width="1000px"
    >
      <el-form
        :model="addDialog"
        :rules="rules"
        ref="form"
        class="notice-form"
        label-width="140px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="优惠券管理代码：" prop="couponCode">
              <el-select
                clearable
                size="small"
                v-model="addDialog.couponCode"
                filterable
              >
                <template v-for="(value, key) in dictData['coupon_code']">
                  <el-option
                    :key="value.value"
                    :label="value.label"
                    :value="value.value"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="优惠券名称：" prop="couponName">
              <el-input size="small" v-model="addDialog.couponName"></el-input>
            </el-form-item>
          </el-col>
          <div v-for="(record, index) in addDialog.schemeList" :key="index">
            <el-col :span="24">
              <el-form-item label="1、触发条件，满：" prop="createTime">
                <el-input
                  style="width:100px"
                  size="small"
                  v-model="record.triggerFull"
                  onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                ></el-input>
                元
                <a @click="handleAddScheme" style="margin: 0 8px 0 0;">新增</a>
                <a v-if="index > 0" @click="handleDeleteScheme(index)">删除</a>
              </el-form-item>
            </el-col>
            <div class="sku-list">
              <el-table
                id="outTable"
                ref="table"
                :data="record.planList"
                tooltip-effect="dark"
                style="width: 95%;margin: 0 0 0 16px;"
                border
                :header-cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column prop="name" label="优惠券类型" align="center">
                  <template slot-scope="scope">
                    <el-select
                      clearable
                      size="small"
                      v-model="scope.row.couponType"
                      filterable
                    >
                      <template v-for="(value, key) in dictData['coupon_type']">
                        <el-option
                          :key="value.value"
                          :label="`${value.label}`"
                          :value="value.value"
                        ></el-option>
                      </template>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="使用条件，满" align="center">
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      v-model="scope.row.useFull"
                      onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                      maxlength="100"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="减/折扣" align="center">
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                      v-model="scope.row.discount"
                      maxlength="100"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每人限领" align="center">
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                      v-model="scope.row.quota"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="100px" label="启用" align="center">
                  <template slot-scope="scope">
                    <a
                      @click="handleAddCoupon(record.planList)"
                      style="margin: 0 8px 0 0;"
                      >新增</a
                    >
                    <a
                      v-if="scope.$index > 0"
                      @click="handleDeleteCoupon(record.planList, scope)"
                      >删除</a
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-row>
        <el-col :span="24">
          <el-form-item label="有效期：" prop="validType">
            <el-radio v-model="addDialog.validType" label="01"
              >固定日期</el-radio
            >
            <el-radio v-model="addDialog.validType" label="02"
              >领取后，当天生效，有效天数</el-radio
            >
          </el-form-item>
        </el-col>
        <el-col v-if="addDialog.validType == '01'" :span="24">
          <el-form-item label="" prop="time">
            <el-date-picker
              size="small"
              v-model="addDialog.time"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-if="addDialog.validType == '02'" :span="24">
          <el-form-item label="" prop="validDay">
            <el-input
              style="width:100px"
              size="small"
              v-model="addDialog.validDay"
            ></el-input>
            天
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="适用产品：" prop="productType">
            <el-radio v-model="addDialog.productType" label="01">全部</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否启用：" prop="isEnable">
            <el-radio v-model="addDialog.isEnable" label="1">是</el-radio>
            <el-radio v-model="addDialog.isEnable" label="0">否</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addDialog.dialogVisible = false"
          >关闭</el-button
        >
        <el-button type="primary" size="small" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { listAuth, auditAuth } from "@/api/business/merchantManage"
import {
  listCoupon,
  getGiveInfo,
  addCoupon,
  getInfo,
} from "@/api/business/coupon"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        couponCode: undefined,
        couponName: undefined,
        isEnable: undefined,
        startTime: undefined,
        endTime: undefined,
        time: [],
      },
      form: {
        authStatus: "",
        userName: "",
        authOpinion: "",
      },
      total: 0,
      tableData: [],
      giveList: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        noticeForm: {},
      },
      addDialog: {
        title: "",
        dialogVisible: false,
        validType: "01",
        couponCode: "",
        couponName: "",
        validDay: "",
        time: [],
        productType: "01",
        isEnable: "1",
        schemeList: [
          {
            triggerFull: "",
            planList: [
              {
                couponType: "",
                useFull: "",
                discount: "",
                quota: "",
              },
            ],
          },
        ],
      },
      rules: {
        couponCode: [
          { required: true, message: "请选择优惠券管理代码", trigger: "blur" },
        ],
        couponName: [
          { required: true, message: "请选择优惠券", trigger: "blur" },
        ],
        productType: [
          { required: true, message: "请选择适用产品", trigger: "blur" },
        ],
        isEnable: [
          { required: true, message: "请选择是否启用", trigger: "blur" },
        ],
        validDay: [
          { required: true, message: "请输入有效日期", trigger: "blur" },
        ],
        time: [{ required: true, message: "请输入时间范围", trigger: "blur" }],
      },
      rowData: {},
      isEdit: false,
      userList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    ...mapGetters(["user"]),
  },
  created() {
    // let curDate = new Date()
    // let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    // this.queryParams.time = [
    //   this.parseTime(preDate, "{y}-{m}-{d}"),
    //   this.parseTime(curDate, "{y}-{m}-{d}"),
    // ]
    this.loadData()
  },
  methods: {
    /** 查询公告列表 */
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.startTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.startTime = ""
        this.queryParams.endTime = ""
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      listCoupon(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleAddScheme() {
      this.addDialog.schemeList.push({
        triggerFull: "",
        planList: [
          {
            couponType: "",
            useFull: "",
            discount: "",
            quota: "",
          },
        ],
      })
    },
    handleDeleteScheme(index) {
      this.addDialog.schemeList.splice(index, 1)
    },
    async handleShowEdit(row) {
      this.addDialog.dialogVisible = true
      let result = await getInfo(row.couponId)
      this.addDialog.schemeList = result.data.schemeList
      this.addDialog.couponCode = result.data.couponCode
      this.addDialog.couponName = result.data.couponName
      this.addDialog.validDay = result.data.validDay
      this.addDialog.isEnable = result.data.isEnable
      this.addDialog.validType = result.data.validType
      this.addDialog.couponId = result.data.couponId

      this.addDialog.time = [
        new Date(result.data.startTime),
        new Date(result.data.endTime),
      ]
    },
    handleAddCoupon(record) {
      record.push({
        couponType: "",
        useFull: "",
        discount: "",
        quota: "",
      })
    },
    handleDeleteCoupon(record, row) {
      record.splice(row.$index, 1)
    },
    resetForm() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        noticeStatus: undefined,
        updateBy: undefined,
        noticeTitle: undefined,
        noticeType: undefined,
        startTime: undefined,
        endTime: undefined,
        time: [],
      }
      this.$refs["form"].resetFields()
    },

    /**显示编辑页面 */
    async handleShowDetail(row) {
      let result = await getGiveInfo({ couponId: row.couponId })
      this.giveList = result.rows
      this.editDialog.title = "已发放明细"
      this.editDialog.dialogVisible = true
    },
    handleShowCoupon() {
      this.addDialog.title = "新增"
      this.addDialog = {
        title: "",
        dialogVisible: true,
        validType: "01",
        couponCode: "",
        couponName: "",
        validDay: "",
        time: [],
        productType: "01",
        isEnable: "1",
        schemeList: [
          {
            triggerFull: "",
            planList: [
              {
                couponType: "",
                useFull: "",
                discount: "",
                quota: "",
              },
            ],
          },
        ],
      }
    },
    handleShowUserDetail(row) {
      this.rowData = Object.assign({}, row)
      this.editDialog.title = "认证审核"
      this.isEdit = false
      this.editDialog.dialogVisible = true
      this.$nextTick(() => {
        this.$refs["form"].clearValidate()
      })
    },

    /**保存公告信息 */
    handleSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = this._.pick(
            this.addDialog,
            "couponCode",
            "couponName",
            "validDay",
            "isEnable",
            "validType",
            "schemeList",
            "couponId"
          )
          // form.couponCode = "02"
          if (this.addDialog.time) {
            form.startTime = this.addDialog.time[0]
            form.endTime = this.addDialog.time[1]
          } else {
            form.startTime = ""
            form.endTime = ""
          }

          addCoupon(form).then((response) => {
            if (response.code == "200") {
              this.$message.success("保存成功！")
              this.addDialog.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error("保存失败")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleDeleteNotice(row) {
      this.$confirm("确认删除公告？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteNotice(row).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
::v-deep .el-badge__content {
  position: relative;
  top: 6px;
  right: 30px;
}
.notice-form {
  padding: 10px 30px 0 0;
  height: 60vh;
  overflow: auto;
}
a {
  cursor: pointer;
}
</style>
